import { useTranslation } from "react-i18next";

export const locales = ["mn", "en"];

const LanguageSwitch = () => {
  const { i18n } = useTranslation();
  const { language, changeLanguage } = i18n;
  // return <div className="w-32 lg:flex md:flex hidden "></div>;
  return (
    <div className='flex items-center capitalize select-none gap-2 text-secondary-100 '>
      <div className={`${language !== "mn" && "text-dark-20"} justify-center`}>
        <img
          alt=''
          src='https://www.countryflags.com/wp-content/uploads/mongolia-flag-png-large.png'
          style={{ width: 25, height: 20, border: 0.5, borderStyle: "solid" }}
        />
        <div
          className='pointer text-center'
          onClick={() => {
            changeLanguage("mn");
          }}
        >
          {"MN"}
        </div>
      </div>
      <div className='bg-gray-200 h-12 mx-2 w-0.5' />
      <div className={`${language !== "cn" && "text-dark-20"} justify-center`}>
        <img
          alt=''
          src='https://www.countryflags.com/wp-content/uploads/china-flag-png-large.png'
          style={{ width: 25, height: 20, border: 0.5, borderStyle: "solid" }}
        />
        <div
          className='pointer text-center'
          onClick={() => {
            changeLanguage("cn");
          }}
        >
          {"CN"}
        </div>
      </div>
    </div>
  );
};

export default LanguageSwitch;
